import React from 'react';

import dayjs from 'dayjs';
import styled from 'styled-components';

import { isManagedBySuperuser } from 'helpers/permissions';
import { useAppSelector } from 'store/hook';
import { SnapshotDataType } from 'types/snapshot';

import SnapshotActor from './SnapshotActor';
import SnapshotActorTooltip from './SnapshotActorTooltip';

const Container = styled.div`
  display: flex;
  white-space: nowrap;
  gap: 4px;
  flex-grow: 1;
`;

interface Props {
  item: SnapshotDataType;
}

const SnapshotSelectorMenuItemContent = ({ item }: Props) => {
  const { currentUser } = useAppSelector((state) => state.auth);
  const dateFormat = isManagedBySuperuser(currentUser) ? 'MMM DD YYYY' : 'MMM YYYY';

  return (
    <SnapshotActorTooltip
      snapshot={item}
      showTooltip={Boolean(currentUser?.isSuperuser || isManagedBySuperuser(currentUser))}
    >
      <Container>
        <span>{dayjs(item.date).format(dateFormat)}</span>
        <SnapshotActor snapshot={item} showTooltip />
      </Container>
    </SnapshotActorTooltip>
  );
};

export default SnapshotSelectorMenuItemContent;
